import {
    takeEvery,
    put
} from 'redux-saga/effects';

import api from 'services/restApiHelper';
import RecommendedDataService from 'services/RecommendedDataService';
const baseUrl = process.env.REACT_APP_BASE_URL;

//tell eslint that Promise is a global var
/*global Promise */

export function* fetchRecommendedVariablesFlow(action) {
    try {
        const response = yield api.get(`${baseUrl}/recommended_variables`);
        yield put({
            type: RecommendedDataService.REC_VARS_FETCH_SUCCESS,
            response
        });
    } catch (error) {
        yield put({
            type: RecommendedDataService.REC_VARS_FETCH_ERROR,
            error
        });
    }
}

export function* watchRecommendedDataRequests() {
    yield takeEvery(RecommendedDataService.REC_VARS_FETCH_START, fetchRecommendedVariablesFlow);
}



// WEBPACK FOOTER //
// ./src/services/sagas/RecommendedDataSaga.js